import { isValidUsername } from 'helper/form';
import { AccountLoginForm } from 'models/account';
import { ErrorValidation } from 'models/error';

export function validate(formValue: AccountLoginForm) {
  const errors: ErrorValidation = {};

  if (!formValue.username) {
    errors.username = 'form.error.required';
  } else if (!isValidUsername(formValue.username)) {
    errors.username = 'form.error.invalid.username.format';
  }

  if (!formValue.password) {
    errors.password = 'form.error.required';
  }

  return errors;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/validation/account/accountLoginForm.ts